import { faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    ACCESS_RIGHT_AREAS,
    ACCESS_RIGHT_TYPES,
} from "../../../constant/permissions";
import { createActionColumn } from "../../../utils/grid-columns";
import { getFormattedDate } from "../../../utils/method";
import capmoLogo from "../../../assets/images/capmo_logo.svg";

/**
 * Get column definitions for the company table
 * @param {function} t - Translation function
 * @param {function} onEdit - Edit callback (row data)
 * @param {function} onDelete - Delete callback (row data)
 * @returns {Array} Column definitions for AG Grid
 */
export const getCompanyTableColumns = (t, onEdit, onDelete) => {
    return [
        {
            headerName: t("companies.provided"),
            field: "provided",
            unSortIcon: true,
            maxWidth: 160,
            minWidth: 160,
            tooltipField: "provided",
            valueFormatter: (params) => {
                return getFormattedDate(params.data.createdAt);
            },
        },
        {
            field: "isFromCapmo",
            headerName: t("common.source"),
            headerTooltip: t("common.source"),
            unSortIcon: true,
            sortable: false,
            cellRenderer: (params) => {
                const data = params.data;
                if (data?.isFromCapmo) {
                    return (
                        <img
                            src={capmoLogo}
                            alt="CAPMO"
                            height="16"
                            width="16"
                            title={t("lv.from-capmo")}
                            className="d-inline-block"
                        />
                    );
                }
                return (
                    <FontAwesomeIcon
                        icon={faHome}
                        title={t("projects.local-project")}
                        className="fs-6"
                    />
                );
            },
            maxWidth: 60,
        },
        {
            headerName: t("companies.name"),
            field: "name",
            unSortIcon: true,
            minWidth: 180,
            tooltipField: "name",
        },
        {
            headerName: t("companies.address"),
            field: "address",
            unSortIcon: true,
            minWidth: 250,
            tooltipField: "address",
        },
        {
            headerName: t("companies.tax-id"),
            field: "taxId",
            unSortIcon: true,
            minWidth: 150,
            tooltipField: "taxId",
        },
        {
            headerName: t("companies.phone"),
            field: "phoneNumber",
            unSortIcon: true,
            minWidth: 150,
            tooltipField: "phoneNumber",
        },
        createActionColumn({
            t,
            actions: [
                {
                    permission: {
                        area: ACCESS_RIGHT_AREAS.COMPANIES,
                        action: ACCESS_RIGHT_TYPES.EDIT,
                    },
                    onClick: onEdit,
                    label: "help.action-edit",
                    show: (data) => !data?.isFromCapmo,
                },
                {
                    permission: {
                        area: ACCESS_RIGHT_AREAS.COMPANIES,
                        action: ACCESS_RIGHT_TYPES.DELETE,
                    },
                    onClick: onDelete,
                    label: "help.action-delete",
                    danger: true,
                    show: (data) => !data?.isFromCapmo,
                },
            ]
        }),
    ];
};
